@if (sites && sites.length) {
    <div>
        <span class="title">Reports Sites:</span>
        <div class="editable">
            <div class="ws-overflow-truncate ws-display-inline-block ws-no-margin ws-no-padding"
                 [title]="siteNames">{{ siteNumbers }}
            </div>
            @if (sites.length > 1) {
                <button class="ace-btn btn-link pointer ws-no-margin ws-no-padding ws-no-border"
                        (click)="showSites()"
                        title="View sites">
                    more...
                </button>
            }
        </div>
    </div>
}
